<template>
  <el-card class="transform-card" :body-style="{ padding: '28px' }">
    <!-- 标题区域 -->
    <div slot="header" class="card-header">
      <span class="header-title">
        <i class="el-icon-edit-outline"></i> CK转换工具 · Askook
      </span>
    </div>

    <!-- 表单区域 -->
    <el-form label-position="top" size="small">
      <el-form-item label="GBO的CK">
        <el-input
          type="textarea"
          v-model="inputText"
          :rows="4"
          placeholder="请将需要转换的CK粘贴到这里"
          clearable
          class="input-textarea"
        />
      </el-form-item>

      <!-- 方案切换 + 转换按钮 + 重置按钮 -->
      <el-form-item>
        <div class="action-bar">
            <el-button @click="convert('1')" :type="convertScheme === '1' ? 'primary' : 'default'" size="large" >小刀转换</el-button>
            <el-button @click="convert('2')" :type="convertScheme === '2' ? 'primary' : 'default'" size="large" >星悦转换</el-button>
            <el-button @click="resetAll" size="large" class="reset-btn">
              <i class="el-icon-refresh-right"></i> 重置
            </el-button>
        </div>
        <div class="hint-text">
          <i class="el-icon-info"></i> 点击后下方显示结果。本站仅做前端转换，无需担心安全问题。
        </div>
      </el-form-item>

      <!-- 结果展示区域 -->
      <el-form-item :label="`${convertScheme === '1' ? '小刀' : '星悦'}转换结果`">
        <div class="result-wrapper">
          <el-input
            ref="resultInput"
            type="textarea"
            v-model="convertedText"
            :rows="5"
            readonly
            resize="vertical"
            placeholder="转换后的文本会出现在这里"
            class="result-textarea"
          />
          <el-button
            :disabled="!convertedText"
            @click="handleCopy"
            icon="el-icon-document-copy"
            class="copy-btn"
            size="small"
          >
            复制
          </el-button>
        </div>
      </el-form-item>
    </el-form>

    <!-- 底部提示 -->
    <div class="rule-hint">
      <span><i class="el-icon-info"></i> 如果为乱码则表示数据有误或已加密，转换失败。</span>
      <span v-if="convertedText" class="copy-status"><i class="el-icon-success"></i> 已就绪</span>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      inputText: '',
      convertedText: '',
      convertScheme: '0'
    };
  },
  methods: {
    hexToString(hex) {
      try {
        const bytes = [];
        for (let i = 0; i < hex.length; i += 2) {
          bytes.push(parseInt(hex.substr(i, 2), 16));
        }
        return new TextDecoder('utf-8').decode(new Uint8Array(bytes));
      } catch (e) {
        return '';
      }
    },

    extractParams(queryStr) {
      const params = {};
      const pairs = queryStr.split('&');
      for (const pair of pairs) {
        const [key, val] = pair.split('=');
        if (key && val !== undefined) {
          params[key] = decodeURIComponent(val);
        }
      }
      return params;
    },

    decodeFull(input) {
      if (!input) return '';
      const decoded = this.hexToString(input);
      if (decoded && !decoded.includes('�')) {
        return decoded;
      }
      return '无法解码，请检查输入是否为有效的十六进制数据';
    },

    extractCoreParams(input) {
      if (!input) return '';
      const decoded = this.hexToString(input);
      if (!decoded || decoded.includes('�')) {
        return '解码失败，无法提取参数';
      }
      
      const patterns = {
        openid: /openid=([^&]+)/i,
        openkey: /openkey=([^&]+)/i,
        session_id: /session_id=([^&]+)/i,
        session_type: /session_type=([^&]+)/i,
        qq_appid: /qq_appid=([^&]+)/i,
        accounttype: /accounttype=([^&]+)/i,
        qq: /"qq":"(\d+)"/,
        proname: /"proname":"([^"]+)"/,
        citname: /"citname":"([^"]+)"/
      };
      
      let result = '';
      const openidMatch = patterns.openid.exec(decoded);
      if (openidMatch) result += `pay_openid=${openidMatch[1]};\n`;
      
      const openkeyMatch = patterns.openkey.exec(decoded);
      if (openkeyMatch) result += `pay_openkey=${openkeyMatch[1]};\n`;
      
      const sessionIdMatch = patterns.session_id.exec(decoded);
      if (sessionIdMatch) result += `pay_session_id=${sessionIdMatch[1]};\n`;
      
      const sessionTypeMatch = patterns.session_type.exec(decoded);
      if (sessionTypeMatch) result += `pay_session_type=${sessionTypeMatch[1]};\n`;
      
      const qqMatch = patterns.qq.exec(decoded);
      if (qqMatch) result += `pay_qq_nickname=${qqMatch[1]};\n`;
      
      if (!result) {
        const ampIndex = decoded.indexOf('?');
        const queryPart = ampIndex !== -1 ? decoded.substring(ampIndex + 1) : decoded;
        const params = this.extractParams(queryPart);
        if (params.openid) result += `pay_openid=${params.openid};\n`;
        if (params.openkey) result += `pay_openkey=${params.openkey};\n`;
        if (params.session_id) result += `pay_session_id=${params.session_id};\n`;
        if (params.session_type) result += `pay_session_type=${params.session_type};\n`;
        if (params.qq) result += `pay_qq_nickname=${params.qq};\n`;
      }
      
      return result || '未找到预期的参数 (openid/openkey等)';
    },

    convert(data) {
      this.convertScheme = data
      if (!this.inputText.trim()) {
        this.convertedText = '';
        return;
      }
      
      if (data === '1') {
        this.convertedText = this.decodeFull(this.inputText.trim());
      } else {
        this.convertedText = this.extractCoreParams(this.inputText.trim());
      }
    },

    // 新增重置方法
    resetAll() {
      this.inputText = '';
      this.convertedText = '';
      this.convertScheme = '0';
      this.$message({ message: '🔄 已重置所有内容', type: 'info', duration: 1500 });
    },

    handleCopy() {
      if (!this.convertedText) return;
      
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.convertedText)
          .then(() => this.$message({ message: '✨ 复制成功', type: 'success', duration: 1200 }))
          .catch(() => this.fallbackCopy());
      } else {
        this.fallbackCopy();
      }
    },
    
    fallbackCopy() {
      const textarea = document.createElement('textarea');
      textarea.value = this.convertedText;
      document.body.appendChild(textarea);
      textarea.select();
      const success = document.execCommand('copy');
      document.body.removeChild(textarea);
      if (success) {
        this.$message({ message: '✨ 复制成功', type: 'success', duration: 1200 });
      } else {
        this.$message({ message: '📋 复制失败，请手动选中复制', type: 'error', duration: 2000 });
        this.$refs.resultInput?.select();
      }
    }
  }
};
</script>

<style scoped>
.transform-card {
  border-radius: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  max-width: 900px;
  margin: 0 auto;
  border: 1px solid #e8edf2;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 0;
}

.header-title {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  letter-spacing: 0.3px;
}

.header-title i {
  color: #5d9cec;
  margin-right: 8px;
  font-size: 20px;
}

:deep(.el-form-item__label) {
  font-size: 14px;
  font-weight: 600;
  padding-bottom: 8px;
  color: #3a4a62;
}

.input-textarea :deep(.el-textarea__inner) {
  border-radius: 12px;
  font-size: 14px;
  font-family: 'SF Mono', 'JetBrains Mono', 'Consolas', monospace;
  background: #fafdff;
  border: 2px solid #e2e8f0;
  transition: all 0.2s;
  line-height: 1.5;
  padding: 12px 16px;
  resize: vertical;
}

.input-textarea :deep(.el-textarea__inner):hover {
  border-color: #c5d9e8;
  background: #ffffff;
}

.input-textarea :deep(.el-textarea__inner):focus {
  border-color: #5d9cec;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(93, 156, 236, 0.1);
}

.action-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

/* 重置按钮样式 */
.reset-btn {
  background: #fef9e6;
  border-color: #ffedd5;
  color: #f59e0b;
  transition: all 0.2s ease;
}

.reset-btn:hover {
  background: #fffbeb;
  border-color: #fbbf24;
  color: #d97706;
  transform: translateY(-1px);
}

.hint-text {
  font-size: 12px;
  color: #7c8ea0;
  background: #f8fafc;
  padding: 6px 12px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.result-wrapper {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.result-wrapper :deep(.el-textarea) {
  flex: 1;
}

.result-textarea :deep(.el-textarea__inner) {
  background: #f8fafc;
  border-radius: 12px;
  font-size: 13px;
  font-family: 'SF Mono', 'JetBrains Mono', 'Consolas', monospace;
  border: 1.5px solid #e2e8f0;
  line-height: 1.5;
  padding: 12px 16px;
  resize: vertical;
}

.result-textarea :deep(.el-textarea__inner):focus {
  border-color: #5d9cec;
  box-shadow: 0 0 0 2px rgba(93, 156, 236, 0.08);
}

.copy-btn {
  height: 42px;
  padding: 0 20px;
  border-radius: 40px;
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  color: #475569;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.2s ease;
}

.copy-btn:hover:not(:disabled) {
  background: #10b981;
  border-color: #10b981;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

.copy-btn:active:not(:disabled) {
  transform: translateY(0);
}

.rule-hint {
  margin-top: 16px;
  font-size: 12px;
  color: #8f9eb2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #eff2f6;
  padding-top: 16px;
}

.copy-status {
  color: #10b981;
  font-weight: 600;
  background: #e8faf0;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 12px;
}

:deep(.el-form-item) {
  margin-bottom: 20px;
}

:deep(.el-message) {
  border-radius: 40px;
  font-weight: 500;
  font-size: 13px;
  padding: 10px 18px;
}

/* 输入框醒目效果 */
.input-textarea :deep(.el-textarea__inner)::placeholder {
  color: #b8c5d6;
  font-weight: 400;
}
</style>